const util = {
  addCookie: function (name, value, options) {
    if (arguments.length > 1 && name !== null) {
      if (options === null) {
        options = {};
      }
      if (value === null) {
        options.expires = -1;
      }
      if (typeof options.expires === "number") {
        let time = options.expires;
        let expires = options.expires = new Date();
        expires.setTime(expires.getTime() + time * 1000);
      }
      document.cookie = encodeURIComponent(String(name)) + "=" + encodeURIComponent(String(value)) + (options.expires ? "; expires=" + options.expires.toUTCString() : "") + (options.path ? "; path=" + options.path : "") + (options.domain ? "; domain=" + options.domain : "") + (options.secure ? "; secure" : "");
    }
  },
  getCookie: function (name) {
    if (name !== null) {
      let value = new RegExp("(?:^|; )" + encodeURIComponent(String(name)) + "=([^;]*)").exec(document.cookie);
      return value ? decodeURIComponent(value[1]) : null;
    }
  },
  removeCookie: function (name, options) {
    this.addCookie(name, null, options);
  },
  addDefaultCookie: function (name, value) {
    this.addCookie(name, value, {path: "/", expires: 2 * 3600})
  },
  numDouble(num) {
    if (num >= 0 && num < 10) {
      return '0' + num
    }
    return num
  },
  dateArr(dataStr) {
    /*2018-05-30 00:00:00=>["2018", "04", "30", "00", "00", "00"]*/
    let arr = dataStr.replace(/-/g, ':').replace(' ', ':').split(':');
    arr[1]--;
    return new Date(...arr)
  },
  dateStr(date, showTime = false) {
    /*Date=>yyyy-mm-dd hh:mm:ss*/
    if (date instanceof Date && !isNaN(date.getTime())) {
      let arr = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      if (showTime) {
        arr = arr.concat([date.getHours(), date.getMinutes(), date.getSeconds()])
      }
      arr = arr.map((x) => this.numDouble(x))
      let str = `${arr[0]}-${arr[1]}-${arr[2]}`
      if (showTime) {
        str += ` ${arr[3]}:${arr[4]}:${arr[5]}`
      }
      return str
    }
  },
  getURLParameter(name) {
    //获取链接中的制定参数
    return (new RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [undefined, null])[1];
  },
  getRequest() {
    //获取参数对象
    const url = location.search;
    let theRequest = {};
    if (url.indexOf("?") !== -1) {
      const str = url.substr(1);
      const arr = str.split("&");
      for (let i = 0; i < arr.length; i++) {
        theRequest[arr[i].split("=")[0]] = (arr[i].split("=")[1]);
      }
    }
    return theRequest;
  },
  setParam: function (param, value) {
    //设置一个新的url参数
    const query = location.search.substring(1);
    if (query.indexOf(param) > -1) {
      const firstParam = query.split(param)[0];
      const secondParam = query.split(param)[1];
      if (secondParam.indexOf("&") > -1) {
        const lastParam = secondParam.substring(secondParam.indexOf('&') + 1);
        return '?' + firstParam + param + '=' + value + '&' + lastParam;
      } else {
        if (firstParam) {
          return '?' + firstParam + param + '=' + value;
        } else {
          return '?' + param + '=' + value;
        }
      }
    } else {
      if (query === '') {
        return '?' + param + '=' + value;
      } else {
        return '?' + query + '&' + param + '=' + value;
      }
    }
  },
  getNum(str,index){
    if(typeof str==='number'){
      return str
    }
    const tyArr = str.replace(',', '').match(/(\d+(\.\d+)?)/g);
    const x = (index >= 0) ? index : (tyArr.length + index) || 0;
    return tyArr[x];
  },
  dateFormat(date) {
    let cn = date.split('-');
    let en = date.split('/');
    if (cn.length === 3) {
      return `${cn[1]}/${cn[2]}/${cn[0]}`
    } else if (en.length === 3) {
      return `${en[2]}-${en[0]}-${en[1]}`
    }
    return date
  },
  loadJs(type, str, code_location) {
    let script_dom = document.createElement('script');
    script_dom.language = 'javascript';
    script_dom.type = 'text/javascript';
    script_dom.classList='tracking-codes'
    if (type === 2) {
      //引入
      script_dom.async = 'async';
      script_dom.src = str;
    } else {
      //自定义
      script_dom.text = str;
    }
    if (code_location === 1) {
      let head = document.getElementsByTagName('head').item(0);
      head.appendChild(script_dom);
    } else if (code_location === 2) {
      document.body.insertBefore(script_dom, document.body.firstElementChild);
    } else {
      document.body.appendChild(script_dom);
    }
  },
  DAY:86400000
}
export default util
